/**
 * isZenkakuLen関数の引数のVO。
 * ※VB.Netの参照渡し(ByRef)に対応するためのVO
 * チェック対象文字列
 */
export class CheckValByrefArgVO {
  /**
   * チェック対象文字列
   */
  chkVal!: string;
}
